import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext';
import './PolicyPages.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-header">
          <h1>{t('privacyPolicy')}</h1>
          <p className="last-updated">
            {t('lastUpdated')}: {new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }).format(new Date())}
          </p>
        </div>

        <div className="policy-content">
          <section className="policy-section">
            <h2>{t('privacyIntroTitle')}</h2>
            <p>{t('privacyIntroText')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('informationWeCollect')}</h2>
            <h3>{t('personalInformation')}</h3>
            <ul>
              <li>{t('infoNameEmail')}</li>
              <li>{t('infoPhoneAddress')}</li>
              <li>{t('infoEmploymentHistory')}</li>
            </ul>

            <h3>{t('usageData')}</h3>
            <ul>
              <li>{t('dataIPAddress')}</li>
              <li>{t('dataBrowserType')}</li>
              <li>{t('dataPagesVisited')}</li>
              <li>{t('dataTimeSpent')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('howWeUseInformation')}</h2>
            <ul>
              <li>{t('useProvideServices')}</li>
              <li>{t('useMatchEmployees')}</li>
              <li>{t('useCommunication')}</li>
              <li>{t('useImproveServices')}</li>
              <li>{t('useLegalCompliance')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('informationSharing')}</h2>
            <p>{t('sharingIntro')}</p>
            <ul>
              <li><strong>{t('withEmployers')}:</strong> {t('sharingEmployers')}</li>
              <li><strong>{t('withServiceProviders')}:</strong> {t('sharingProviders')}</li>
              <li><strong>{t('legalRequirements')}:</strong> {t('sharingLegal')}</li>
              <li><strong>{t('withConsent')}:</strong> {t('sharingConsent')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('dataSecurity')}</h2>
            <p>{t('securityMeasures')}</p>
            <ul>
              <li>{t('securityEncryption')}</li>
              <li>{t('securityAccessControl')}</li>
              <li>{t('securityRegularAudits')}</li>
              <li>{t('securityTraining')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('yourRights')}</h2>
            <ul>
              <li>{t('rightAccess')}</li>
              <li>{t('rightCorrection')}</li>
              <li>{t('rightDeletion')}</li>
              <li>{t('rightObject')}</li>
              <li>{t('rightDataPortability')}</li>
              <li>{t('rightWithdrawConsent')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('cookies')}</h2>
            <p>{t('cookiesDescription')}</p>
            <ul>
              <li><strong>{t('essentialCookies')}:</strong> {t('essentialCookiesDesc')}</li>
              <li><strong>{t('analyticsCookies')}:</strong> {t('analyticsCookiesDesc')}</li>
              <li><strong>{t('preferenceCookies')}:</strong> {t('preferenceCookiesDesc')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('changesToPolicy')}</h2>
            <p>{t('policyChangesText')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('contactUsPrivacy')}</h2>
            <p>{t('contactPrivacyText')}</p>
            <div className="contact-info">
              <p><strong>{t('email')}:</strong> info@urugowoc.com</p>
              <p><strong>{t('phone')}:</strong> +250 788350577</p>
              <p><strong>{t('address')}:</strong> Kayonza, Rwanda</p>
            </div>
          </section>
        </div>

        <div className="policy-footer">
          <Link to="/" className="back-home">{t('backToHome')}</Link>
          <Link to="/terms" className="policy-link">{t('viewTerms')}</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;